module.exports = __webpack_public_path__ + "img/no_media_light.991ddf99.png";